import { render, staticRenderFns } from "./SettingsHeight.vue?vue&type=template&id=6835f053&"
import script from "./SettingsHeight.vue?vue&type=script&lang=js&"
export * from "./SettingsHeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports